import { Environment, Float, OrbitControls, useGLTF } from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import { useEffect } from "react";
import * as THREE from "three";

const TechIconCardExperience = ({ model }) => {
  // Vérifie si c'est un lien spline ou un fichier GLB
   const isSplineUrl = model.modelPath?.includes("my.spline.design");

  if (isSplineUrl) {
    // Ajoute /embedded si pas déjà présent
    const embedUrl = model.modelPath;

    return (
      <iframe
        src={embedUrl}
        frameBorder="0"
        width="100%"
        height="100%"
        className="w-full h-full rounded-xl"
        allow="autoplay; fullscreen"
        loading="lazy"
        title={model.name}
      />
    );
  }

  const scene = useGLTF(model.modelPath);

  useEffect(() => {
    if (model.name === "Interactive Developer") {
      scene.scene.traverse((child) => {
        if (child.isMesh && child.name === "Object_5") {
          child.material = new THREE.MeshStandardMaterial({ color: "white" });
        }
      });
    }
  }, [scene]);

  return (
    <Canvas>
      <ambientLight intensity={0.3} />
      <directionalLight position={[5, 5, 5]} intensity={1} />
      <spotLight
        position={[10, 15, 10]}
        angle={0.3}
        penumbra={1}
        intensity={2}
      />
      <Environment preset="city" />

      <Float speed={5.5} rotationIntensity={0.5} floatIntensity={0.9}>
        <group scale={model.scale} rotation={model.rotation}>
          <primitive object={scene.scene} />
        </group>
      </Float>

      <OrbitControls enableZoom={false} />
    </Canvas>
  );
};

export default TechIconCardExperience;
